import { useState } from 'react';
import EditableText from './EditableText';
import OutsideClickListener from './OutsideClickListener';
import { cn } from '@/app/lib/utils';

type ToggleInlineEditProps = {
  value?: string | number;
  view: React.ReactNode;
  editType?: 'text' | 'number';
  onSave: (value: string | number) => void;
  wrapperClassName?: string;
  textWrapperClassName?: string;
  inputClassName?: string;
};

const ToggleInlineEdit = ({
  value,
  view,
  editType = 'text',
  onSave,
  wrapperClassName,
  textWrapperClassName,
  inputClassName,
}: ToggleInlineEditProps) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <OutsideClickListener
      className={cn('w-full h-full', wrapperClassName)}
      onOutsideClick={() => {
        setTimeout(() => {
          setIsEditing(false);
        }, 0);
      }}
    >
      <div className={cn('w-full h-full', textWrapperClassName)} onClick={() => setIsEditing(true)}>
        {isEditing ? (
          <EditableText
            initialEditing={true}
            inputClassName={inputClassName}
            isTableCell={true}
            initialValue={value as any}
            type={editType}
            onSave={(v: any) => {
              onSave(v);
            }}
          />
        ) : (
          view
        )}
      </div>
    </OutsideClickListener>
  );
};

export default ToggleInlineEdit;
